import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import logoExpo from '../../img/logo-expo-medica.png';
import { Link } from 'react-router-dom';

class Footer extends Component {
   constructor(props) {
      super(props);
      this.state = {};
   }
   render() {
      return (
         <footer className="flex">
            <div className="justify-center">
               <div className="column">
                  <div className="row-responsive">
                     <div className="column align-center justify-center column-footer">
                        <div className="white-space-8"></div>
                     </div>
                     <div className="column align-start justify-start">
                        <div className="row align-start justify-start">
                           <div className="f-oimage responsive-img justify-center align-start">
                              <img src={logoExpo} alt="ExpoMedica" />
                           </div>
                        </div>
                        <div className="row align-start justify-start">
                           <div className="column">
                              <p className="text-center color-white">
                                 Av. Coba Lt.25-1 MZ.13 SM.22{' '}
                              </p>
                              <p className="text-center color-white">
                                 Loc. 102 y 103
                              </p>
                              <p className="text-center color-white">
                                 Cancun, Q. Roo 77500
                              </p>
                           </div>
                        </div>
                     </div>
                     <div className="column align-center justify-center padding-footer">
                        <div className="row align-center justify-center">
                           <div className="white-space-8"></div>
                        </div>
                        <div className="row align-center justify-start">
                           <h3 className="color-white">Contacto</h3>
                        </div>
                        <div className="row align-center justify-center">
                           <div className="white-space-8"></div>
                        </div>
                        <div className="row align-center justify-start">
                           <p className="color-white">
                              <i className="fas fa-envelope color-white"></i>
                              <a href="mailto:contacto@expomedica.mx">
                                 {' '}
                                 &nbsp; contacto@expomedica.mx
                              </a>
                           </p>
                        </div>
                        <div className="row align-center justify-center">
                           <div className="white-space-8"></div>
                        </div>
                        <div className="row align-center justify-start">
                           <p className="color-white">
                              <i className="fas fa-phone"></i>
                              <a href="tel:9988879509">&nbsp; (998)8879509</a>
                           </p>
                        </div>
                        <div className="row align-center justify-center">
                           <div className="white-space-8"></div>
                        </div>
                        <div className="row align-center justify-start">
                           <a
                              rel="noopener noreferrer"
                              className="color-white"
                              target="_blank"
                              href="https://www.facebook.com/expomedicacancun/?ref=br_rs"
                           >
                              <i className="fab fa-facebook"></i>
                              &nbsp; /expomedicacancun
                           </a>
                        </div>
                        <div className="row align-center justify-center">
                           <div className="white-space-8"></div>
                        </div>
                        <div className="row align-center justify-start">
                           <a
                              rel="noopener noreferrer"
                              target="_blank"
                              className="color-white"
                              href="https://www.instagram.com/expomedicacancun/?hl=es-la"
                           >
                              <i className="fab fa-instagram"></i>
                              &nbsp; /expomedicacancun
                           </a>
                        </div>
                        <div className="row align-center justify-center">
                           <div className="white-space-8"></div>
                        </div>
                        <div className="row align-center justify-center"></div>
                     </div>
                     <div className="column align-center justify-start padding-footer">
                        <div className="row align-center justify-center">
                           <div className="white-space-8"></div>
                        </div>
                        <div className="row align-center justify-start">
                           <h3 className="color-white">Información</h3>
                        </div>
                        <div className="row align-center justify-center">
                           <div className="white-space-8"></div>
                        </div>

                        <div className="row align-center justify-start">
                           <Link to="/nosotros" className="color-white">
                              Nosotros
                           </Link>

                           {/* </a> */}
                        </div>
                        <div className="row align-center justify-center">
                           <div className="white-space-8"></div>
                        </div>
                        <div className="row align-center justify-start">
                           <Link to="/privacidad" className="color-white">
                              Aviso de privacidad
                           </Link>
                        </div>
                        <div className="row align-center justify-center">
                           <div className="white-space-8"></div>
                        </div>
                        <div className="row align-center justify-start">
                           <Link to="/politicas" className="color-white">
                              Políticas de compra
                           </Link>
                        </div>
                     </div>
                     {/*
                        <div className="column align-center justify-start">
                           <div className="row align-center justify-start">
                              <div className="white-space-8"></div>
                           </div>
                           <div className="row align-center justify-start">
                              <h3 className="color-white">Mi cuenta</h3>
                           </div>

                           <div className="row align-center justify-center">
                              <div className="white-space-8"></div>
                           </div>
                           {this.props.auth ? (
                              <React.Fragment>
                                 <div className="row align-center justify-start">
                                    <Link to="/pedidos" className="color-white">
                                       Mis Pedidos
                                    </Link>
                                 </div>
                                 <div className="row align-center justify-center">
                                    <div className="white-space-8"></div>
                                 </div>
                                 <div className="row align-center justify-start">
                                    <Link
                                       to="/facturas"
                                       className="color-white"
                                    >
                                       Mis Facturas
                                    </Link>
                                 </div>
                                 <div className="row align-center justify-center">
                                    <div className="white-space-8"></div>
                                 </div>
                                 <div className="row align-center justify-start">
                                    <Link to="/carrito" className="color-white">
                                       Carrito
                                    </Link>
                                 </div>
                              </React.Fragment>
                           ) : (
                              <React.Fragment>
                                 <div className="row align-center justify-start">
                                    <Link
                                       to="/registro"
                                       className="color-white"
                                    >
                                       Regístrate
                                    </Link>
                                 </div>
                              </React.Fragment>
                           )}
                        </div>
                           */}
                     <div className="column column-footer">
                        <div className="white-space-8"></div>
                     </div>
                  </div>
                  <div className="row">
                     <div className="white-space-16"></div>
                  </div>
                  {/*<div className="row align-center justify-center">
							<div className="column justify-center align-center">
								<h4 className="color-white">Transacciones vía:</h4>
								<div className="oimage responsive-img justify-center">
									<img src={logoOpenPay} alt="OpenPay" />
								</div>
							</div>
						</div>*/}
               </div>
            </div>
         </footer>
      );
   }
}

function mapStateToProps(state) {
   return {
      auth: state.auth,
   };
}

export default withRouter(connect(mapStateToProps)(Footer));



// WEBPACK FOOTER //
// ./src/components/Footer/footer.js